/**
 * Capability-scope predicates. Distinct from roles.ts (which gates the admin
 * area by UserRole) — scopes gate *features*, and a member earns them directly
 * or via a group. `/api/me` returns the effective set (direct ∪ group), so a
 * group-granted scope shows up here just like a direct grant.
 *
 * Scopes are advisory in the UI only — the orchestrator authoritatively enforces
 * them on every request. This just decides what to show before the first call.
 */

/** The scope required to use the assistant (orchestrator's POST /api/agent gate). */
export const AGENT_RUN_SCOPE = 'Agent.Run';

export const hasAgentAccess = (scopes: string[] | undefined): boolean =>
  scopes?.includes(AGENT_RUN_SCOPE) ?? false;
